import React from 'react';
import not from 'ramda/src/not';
import { ArticleAdviceResponse, ArticleAdviceResponseValue } from '../ArticleAdviceResponse';
import { Container } from '../Container';
import { Divider } from '../../wag-react/core-components/divider';
export type ArticleAdviceResponsesValue = ArticleAdviceResponseValue[];
type Props = {
  value: ArticleAdviceResponsesValue;
};
const isNotTail = (arr: unknown[], index: number) => not(index + 1 === arr.length);
export const ArticleAdviceResponses = ({
  value
}: Props) => <>
    {value.map((response, index) => <Container key={response.text}>
        <ArticleAdviceResponse value={response} />
        {isNotTail(value, index) && <Divider />}
      </Container>)}
  </>;
export type ArticleAdviceResponsesProps = Props;